module.exports = __webpack_public_path__ + "static/img/2.5435510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/2.png
// module id = K2Mb
// module chunks = 0